import _objectIsPrototypeOf from "../internals/object-is-prototype-of";
var exports = {};
var isPrototypeOf = _objectIsPrototypeOf;
var $TypeError = TypeError;
exports = function (it, Prototype) {
  if (isPrototypeOf(Prototype, it)) return it;
  throw new $TypeError("Incorrect invocation");
};
export default exports;